<!-- eslint-disable no-console -->
<script setup lang='ts'>
import { imageTransform } from '@qctsw/common'
import type { UploadCustomRequestOptions } from 'naive-ui'
import { FILE_UPLOAD_TYPE } from '@/shared/types'
import { customSingleFileUpdate } from '@/logic/common/fileUpload'

const props = withDefaults(defineProps<{
  fileType?: FILE_UPLOAD_TYPE
  modelValue?: string
}>(), {
  fileType: FILE_UPLOAD_TYPE.other,
})
const emits = defineEmits({
  'update:modelValue': (data: string) => typeof data === 'string',
})

function uploadFile(arg: UploadCustomRequestOptions) {
  customSingleFileUpdate(arg)?.then((res) => {
    res && emits('update:modelValue', res.data)
  })
}
</script>

<template>
  <NUpload :show-file-list="false" accept="image/*" :custom-request="uploadFile">
    <slot>
      <div w-25 h-25 rounded-full overflow-hidden cursor-pointer border="1 gray-200">
        <NAvatar img-hover round :size="100" object-fit="cover" :src="imageTransform(props.modelValue || '') ">
          <span v-if="!props.modelValue">上传头像</span>
        </NAvatar>
      </div>
    </slot>
  </NUpload>
</template>
